var map = {
	"./Economics.png": "7a71",
	"./Physics.png": "b059",
	"./art.png": "5eb7",
	"./biology.png": "4bbd",
	"./chemistry.png": "44ab",
	"./engineering.png": "ea23",
	"./environthon.png": "44fc",
	"./finance.png": "a02c",
	"./geography.png": "08f5",
	"./history.png": "87e3",
	"./informatics.png": "a87c",
	"./linguistic.png": "26c0",
	"./literature.png": "1a4c",
	"./math.png": "b10b",
	"./musicology.png": "2c14",
	"./philosophy.png": "80c4",
	"./psychology.png": "b79c",
	"./statistics.png": "bbc4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a7f";